/**
 * Add files up to the maximum number of files allowed.
 * @param addedFiles - The files to add.
 * @param currentFiles - The current files.
 * @returns The files to add.
 */
export const addFilesUpToMax = ({
	addedFiles,
	currentFileCount,
	maxFileCount,
}: {
	addedFiles: File[];
	currentFileCount: number;
	maxFileCount: number;
}): File[] => {
	const remainingSlots = maxFileCount - currentFileCount;
	const limitedFiles = addedFiles.slice(0, remainingSlots > 0 ? remainingSlots : 0);
	return limitedFiles;
};
